import { createContext, useContext } from 'react';
import { DoctorProfile } from 'types/api/doctors';

/**
 * Context bridging the parent DoctorProfile useEffect-driven fetch
 * to every sub-page that used to read from the Apollo cache via
 * useQuery(GET_DOCTOR_PROFILE, fetchPolicy: cache-only). Replaces
 * the implicit Apollo cache + client.refetchQueries cycle.
 *
 * `refresh` triggers a parent re-fetch (refreshKey bump) and is the
 * REST equivalent of client.refetchQueries(GET_DOCTOR_PROFILE).
 */
export interface DoctorProfileContextValue {
  profile: DoctorProfile | null;
  loading: boolean;
  refresh: () => void;
}

export const DoctorProfileContext = createContext<
  DoctorProfileContextValue | undefined
>(undefined);

export const useDoctorProfile = (): DoctorProfileContextValue => {
  const ctx = useContext(DoctorProfileContext);

  if (!ctx) {
    throw new Error('useDoctorProfile must be used within DoctorProfile');
  }

  return ctx;
};
